"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InteractionTagPrimary: function() {
        return _index.InteractionTagPrimary;
    },
    interactionTagPrimaryClassNames: function() {
        return _index.interactionTagPrimaryClassNames;
    },
    renderInteractionTagPrimary_unstable: function() {
        return _index.renderInteractionTagPrimary_unstable;
    },
    useInteractionTagPrimaryStyles_unstable: function() {
        return _index.useInteractionTagPrimaryStyles_unstable;
    },
    useInteractionTagPrimary_unstable: function() {
        return _index.useInteractionTagPrimary_unstable;
    }
});
const _index = require("./components/InteractionTagPrimary/index");
